import type { FileKind } from "@gettactic/helpers/src/files/fileType";
import {
  File,
  FileArchive,
  FileAudio,
  FileSpreadsheet,
  FileText,
  FileVideo,
  ImageIcon,
  type LucideIcon,
  Presentation
} from "lucide-react";

const ICONS: Record<FileKind, LucideIcon> = {
  image: ImageIcon,
  document: FileText,
  spreadsheet: FileSpreadsheet,
  presentation: Presentation,
  archive: FileArchive,
  video: FileVideo,
  audio: FileAudio,
  other: File
};

/** The lucide icon that stands in for a file family. */
export const getFileKindIcon = (kind: FileKind): LucideIcon => ICONS[kind];
